module.exports = __webpack_public_path__ + "static/media/logo.37aa9043.svg";